import React from "react";

function Permanent({ backgroundColor, flexDirection, permanentData, image }) {
  const { heading, description, subheading, bulletPoints, buttonText } = permanentData;
  const isReverse = flexDirection === "row-reverse";

  return (
    <section className="layout-band" style={{ backgroundColor }}>
      <div
        className={`layout-container layout-section flex flex-col ${
          isReverse ? "lg:flex-row-reverse" : "lg:flex-row"
        } items-center gap-8`}
      >
        <div className="w-full lg:w-1/2 flex justify-center">
          <img src={image} alt={heading} className="w-full max-w-md rounded-lg object-cover" />
        </div>
        <div className="w-full lg:w-1/2 flex justify-center">
          <div className="rounded-md p-4 sm:p-6 shadow-lg bg-white w-full max-w-lg">
            <h2 id="heading-md">{heading}</h2>
            <p className="text-gray-600 pt-4">{description}</p>
            {subheading && <h4 className="py-2 font-semibold">{subheading}</h4>}
            <ul className="list-disc list-inside text-gray-600 pb-2 space-y-1">
              {bulletPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
            <button
              type="button"
              className="bg-green-800 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4 w-full sm:w-auto"
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Permanent;
